import { compare, multiply } from "dinero.js"

import { toDinero } from "../../../../../../modules/currency/currencyLib"
import { MonetaryAmount } from "../../../../../../modules/currency/currencyTypes"

export type ExtraServiceBreakdown =
    | { kind: "seats"; pricePerSeat: MonetaryAmount }
    | { kind: "min"; minPrice: MonetaryAmount }
    | { kind: "max"; maxPrice: MonetaryAmount }
    | null

/**
 * Determines which breakdown label to show for a PER_SEAT extra service:
 * - "seats"  → raw (seatCount × pricePerSeat) is within any min/max bounds
 * - "min"    → raw fell below minimumPrice, clamped up
 * - "max"    → raw exceeded maximumPrice, clamped down
 */
export function getExtraServiceBreakdown(
    seatCount: number,
    pricePerSeat: MonetaryAmount | undefined,
    minPrice: MonetaryAmount | undefined,
    maxPrice: MonetaryAmount | undefined,
): ExtraServiceBreakdown {
    if (!pricePerSeat) {
        if (minPrice) return { kind: "min", minPrice }
        return null
    }

    const raw = multiply(toDinero(pricePerSeat), seatCount)

    if (minPrice && compare(raw, toDinero(minPrice)) < 0) {
        return { kind: "min", minPrice }
    }
    if (maxPrice && compare(raw, toDinero(maxPrice)) > 0) {
        return { kind: "max", maxPrice }
    }
    return { kind: "seats", pricePerSeat }
}
